import { History } from 'lucide-react';
import ProductCard from '@/components/product/ProductCard';
import { useRecentlyViewed } from '@/context/RecentlyViewedContext';

const RecentlyViewed = ({ excludeId = null, title = 'Recently Viewed' }) => {
  const { recentlyViewed } = useRecentlyViewed();

  const items = recentlyViewed.filter((p) => p.id !== excludeId);

  if (items.length === 0) return null;

  return (
    <section className="py-4 sm:py-8 bg-white" data-testid="recently-viewed-section">
      <div className="max-w-7xl mx-auto px-3 sm:px-6">
        <div className="flex items-center gap-2 mb-3 sm:mb-5">
          <History className="w-5 h-5 text-[#0047AB]" />
          <h2 className="text-base sm:text-lg md:text-xl font-outfit font-bold text-slate-900">
            {title}
          </h2>
        </div>

        {/* Horizontal scroll on mobile, grid on desktop */}
        <div className="flex md:grid md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4 overflow-x-auto pb-2 md:pb-0 -mx-3 px-3 md:mx-0 md:px-0 scrollbar-hide">
          {items.map((product) => (
            <div key={product.id} className="min-w-[150px] w-[150px] sm:min-w-[170px] sm:w-[170px] md:min-w-0 md:w-auto shrink-0">
              <ProductCard product={product} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RecentlyViewed;
